var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout--application"},[_c('navigation-menu'),_c('application-toolbar'),_vm._t("default"),_c('app-snackbar'),_c('modal-session-notice')],2)}
var staticRenderFns = []

export { render, staticRenderFns }